<template>
  <transition name="el-zoom-in-center">
    <el-card v-show="add.addshow" class="box-card" style="text-align: left;">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>新增扩展属性</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="add.addshow=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="add.form" label-width="110px" :rules="rules">
        <el-row>
          <el-col :span="18" :offset="6">
            <!-- <el-form-item label="生产工单" prop="orderno">
              <el-input v-model.trim="form.orderno" style="width:200px" />
            </el-form-item>
            <el-form-item label="生产批次" prop="batchno">
              <el-input v-model.trim="form.batchno" style="width:200px" />
            </el-form-item>
            <el-form-item label="产品编码" prop="product_code">
              <el-select
                style="width:200px"
                v-model="form.product_code"
                placeholder="请输入产品名称模糊匹配或者下拉选择"
                :remote-method="getproductlist"
                filterable
                remote
                :loading="productloading"
              >
                <el-option
                  v-for="item in productlist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>-->
            <el-form-item label="标题" prop="column_title">
              <el-input v-model.trim="add.form.column_title" style="width:200px" />
            </el-form-item>
            <el-form-item label="说明" prop="column_value">
              <el-input v-model.trim="add.form.column_value" style="width:200px" />
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-switch
                v-model="add.form.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="0"
                :inactive-value="1"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <template>
                <el-input-number
                  v-model="add.form.sort"
                  controls-position="right"
                  :min="0"
                  :max="1000"
                ></el-input-number>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <br />
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="resetForm('form')">重置</el-button>
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import PanThumb from "@/components/PanThumb";
import { productlist } from "@/api/base";
import { workordextendadd } from "@/api/plant";
export default {
  components: { PanThumb },
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null,
          form: {
            workorder_senior_id: null,
            column_title: null,
            column_value: null,
            status: 0,
            sort: 0
          }
        };
      }
    }
  },
  data() {
    return {
      // 基础数据
      show: true,
      productloading: false,
      productlist: [],
      storetypelist: [
        {
          value: 2,
          label: "公司仓库"
        },
        {
          value: 3,
          label: "经销商仓库"
        }
      ],
      rules: {
        column_title: [
          { required: true, message: "请输入标题", trigger: "blur" }
        ],
        column_value: [
          { required: true, message: "请输入说明", trigger: "blur" }
        ],
        status: [{ required: true, message: "选择状态", trigger: "blur" }],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { type: "number", message: "必须为数字值" }
        ]
      }
    };
  },
  mounted() {
    this.getproductlist();
  },
  methods: {
    // 获取产品下拉
    getproductlist(value) {
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            for (var i = 0; i < response.data.data.length; i++) {
              var option = {};
              option.value = response.data.data[i].product_code;
              option.label =
                response.data.data[i].product_code +
                "   " +
                response.data.data[i].product_name;
              this.productlist.push(option);
            }
            console.log(this.productlist);
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    // 保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        // 基础表单验证
        if (valid) {
          workordextendadd(this.add.form).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!"
              });
              this.search();
              this.add.addshow = false;
              this.resetForm(this.form);
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
